// extracted by mini-css-extract-plugin
module.exports = {"root":"TermsOfService_root__20L6D","lastUpdated":"TermsOfService_lastUpdated__1LSpD"};